<template>
  <v-row>
    <v-col cols="8" class="contentEditor">
      <v-layout column>
        <v-flex class="text-center">
          <v-card>
            <v-card-text>
              <v-form>
                <v-container grid-list-xl>
                  <v-layout wrap>
                    <v-flex xs12 sm6>
                      <v-text-field
                        @change="saveSnack = true"
                        label="Title"
                        v-model="article.title"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field
                        @change="saveSnack = true"
                        label="URL cuminaivel.ch"
                        v-model="article.url"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 sm10>
                      <v-textarea
                        @change="saveSnack = true"
                        label="Lead"
                        v-model="article.lead"
                      ></v-textarea>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs8 sm6 md3>
                      <v-menu
                        ref="dateMenu"
                        v-model="dateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            @change="saveSnack = true"
                            v-model="article.pubDate"
                            label="Date"
                            hint="YYYY-MM-DD format"
                            persistent-hint
                            prepend-icon="fa-calendar"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          @change="saveSnack = true"
                          v-model="article.pubDate"
                          no-title
                          @input="dateMenu = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs4 sm4 md3>
                      <v-menu
                        ref="timeMenu"
                        v-model="timeMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="article.pubTime"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            @change="saveSnack = true"
                            v-model="article.pubTime"
                            label="Time"
                            prepend-icon="fa-clock"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-if="timeMenu"
                          v-model="article.pubTime"
                          @click:minute="
                            $refs.timeMenu.save(article.pubTime);
                            saveSnack = true;
                          "
                        ></v-time-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs4 sm4 md3>
                      <v-checkbox
                        label="compact mode"
                        v-model="article.isCompact"
                        @change="saveSnack = true"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 sm5>
                      <v-text-field
                        @change="saveSnack = true"
                        label="Author"
                        v-model="article.author"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm5 offset-sm-1>
                      <v-select
                        @change="saveSnack = true"
                        v-model="article.lang"
                        :items="['de', 'it', 'fr']"
                        label="Language"
                        disabled
                      ></v-select>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4>
                      <v-radio-group
                        @change="selectHomeType"
                        v-model="article.homeType"
                      >
                        <v-radio
                          label="Picture from URL"
                          value="pictureFromURL"
                        ></v-radio>
                        <v-radio
                          label="Stored Picture"
                          value="picture"
                        ></v-radio>
                        <v-radio
                          label="Youtube link"
                          value="linkYoutube"
                        ></v-radio>
                      </v-radio-group>
                    </v-flex>
                    <v-flex xs8 v-if="article.homeType === 'picture'">
                      <Gallery
                        :article="article"
                        @change="
                          article.picture.images = $event;
                          saveSnack = true;
                        "
                      ></Gallery>
                    </v-flex>
                    <v-flex xs8 v-if="article.homeType === 'pictureFromURL'">
                      <v-text-field
                        @change="saveSnack = true"
                        label="URL"
                        v-model="article.picture.url"
                      ></v-text-field>
                      <v-text-field
                        @change="saveSnack = true"
                        label="Caption"
                        v-model="article.picture.caption"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs8 v-if="article.homeType === 'linkYoutube'">
                      <v-text-field
                        @change="
                          checkEmbedOrModify();
                          saveSnack = true;
                        "
                        label="Link youtube video"
                        v-model="article.picture.url"
                      ></v-text-field>
                      <v-text-field
                        @change="saveSnack = true"
                        label="Caption"
                        v-model="article.picture.caption"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-combobox
                        v-model="article.tags"
                        :items="$store.state.tags.tags.list[article.lang]"
                        chips
                        @change="saveSnack = true"
                        label="Tags"
                        multiple
                      ></v-combobox>
                    </v-flex>
                    <v-flex xs6>
                      <v-btn @click="importFromURLDialog = true" color="info"
                        >Import full article from URL</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
          </v-card>
          <v-btn
            class="addBlockButton"
            fab
            dark
            small
            color="primary"
            @click="
              newBlockDialog = true;
              insertIndex = 0;
            "
          >
            <v-icon dark>fa-plus</v-icon>
          </v-btn>
        </v-flex>

        <v-flex
          v-for="(block, i) in article.blocks"
          :key="i"
          class="text-center"
        >
          <v-flex xs12 class="text-right h0">
            <v-btn
              class="deleteBlockButton"
              fab
              dark
              small
              color="error"
              @click="
                deleteBlockDialog = true;
                deleteIndex = i;
              "
            >
              <v-icon dark>fa-trash-alt</v-icon>
            </v-btn>
          </v-flex>
          <Gallery
            v-if="block.type === 'gallery'"
            :blockIndex="i"
            :article="article"
            @change="
              block.content = $event;
              saveSnack = true;
            "
          />
          <SurveyBlock
            v-if="block.type === 'survey'"
            :data="block"
            :index="i"
            @change="saveSnack = true"
          />
          <TextBlock
            v-if="block.type === 'text'"
            :data="block"
            :index="i"
            @change="
              block.content = $event;
              saveSnack = true;
            "
          />
          <VideoBlock
            v-if="block.type === 'video'"
            :data="block"
            :index="i"
            @change="
              block.url = $event.url;
              block.description = $event.description;
              saveSnack = true;
            "
          />
          <v-btn
            class="addBlockButton"
            fab
            dark
            small
            color="primary"
            @click="
              newBlockDialog = true;
              insertIndex = i + 1;
            "
          >
            <v-icon dark>fa-plus</v-icon>
          </v-btn>
        </v-flex>
        <v-dialog v-model="newBlockDialog" width="500">
          <v-card>
            <v-card-title class="headline" primary-title
              >New block</v-card-title
            >
            <v-card-text>
              <v-radio-group v-model="newBlockTypeRadio">
                <v-radio label="Text" value="text"></v-radio>
                <v-radio label="Gallery" value="gallery"></v-radio>
                <v-radio label="Video" value="video"></v-radio>
                <v-radio label="Survey" value="survey"></v-radio>
              </v-radio-group>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="addNewBlock()">Create</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="deleteBlockDialog" width="500">
          <v-card>
            <v-card-title class="headline" primary-title
              >Delete block</v-card-title
            >
            <v-card-text
              >Do you want to remove this block definitively?</v-card-text
            >
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="error"
                text
                @click="
                  deleteBlockDialog = false;
                  deleteIndex = -1;
                "
                >Cancel</v-btn
              >
              <v-btn color="error" text @click="deleteBlock()">Delete</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-snackbar v-model="saveSnack" :timeout="0" color="blue darken-3">
          There is new content!
          <v-btn color="error" @click="undoChanges">Cancel</v-btn>
          <v-btn color="success" @click="saveChanges">Save</v-btn>
        </v-snackbar>
      </v-layout>
    </v-col>

    <!-- PREVIEW ----------------------class="contentEditor"---------------------------------->
    <v-col cols="4">
      <v-row>
        <v-col class="preview">
          <v-card class="cardPreview">
            <ion-header>
              <ion-toolbar>
                <ion-buttons slot="start">
                  <ion-button fill="clear">
                    <ion-icon size="large" name="arrow-back"></ion-icon>
                  </ion-button>
                  <ion-button class="ml--10" fill="clear">
                    <ion-img
                      id="titleimg"
                      :src="`${publicPath}title.svg`"
                    ></ion-img>
                  </ion-button>
                </ion-buttons>
                <ion-buttons slot="end">
                  <ion-button fill="clear">
                    <ion-icon size="24px" name="share"></ion-icon>
                  </ion-button>
                </ion-buttons>
              </ion-toolbar>
            </ion-header>

            <ion-content>
              <ion-fab vertical="bottom" horizontal="end" slot="fixed">
                <ion-fab-button id="likeButton" class="down">
                  <ion-icon name="star"></ion-icon>
                </ion-fab-button>
              </ion-fab>
              <img
                v-if="article.homeType === 'pictureFromURL'"
                :src="article.picture.url"
              />
              <div v-if="article.homeType === 'picture'">
                <ion-slides
                  v-if="
                    article.picture.images != undefined &&
                      article.picture.images.length > 1
                  "
                  pager="true"
                  :options="slideOpts"
                >
                  <ion-slide
                    v-for="(img, j) of article.picture.images"
                    :key="j"
                  >
                    <ion-img :src="img.url"></ion-img>
                  </ion-slide>
                </ion-slides>
                <img
                  v-if="
                    article.picture.images != undefined &&
                      article.picture.images === 1
                  "
                  :src="article.picture.images[0]"
                />
              </div>
              <iframe
                class="video"
                v-if="article.homeType === 'linkYoutube'"
                width="100%"
                :src="article.picture.url"
                frameborder="0"
                allow="encrypted-media;fullscreen;accelerometer; magnetometer; gyroscope"
                allowfullscreen
              ></iframe>
              <p
                v-if="article.homeType === 'pictureFromURL'"
                class="imgCaption"
              >
                {{
                  article.picture.caption != undefined
                    ? article.picture.caption
                    : ""
                }}
              </p>
              <p v-if="article.homeType === 'linkYoutube'" class="imgCaption">
                {{
                  article.picture.caption != undefined
                    ? article.picture.caption
                    : ""
                }}
              </p>
              <h2 class="caption p5">
                <span class="pubDate">
                  <small>{{ article.pubDate + " " + article.pubTime }}</small>
                </span>
                <br />
                <span class="title">{{ article.title }}</span>
              </h2>
              <h4 class="p5 lead">{{ article.lead }}</h4>
              <div class="p5 text-larger color-white">
                <div
                  v-for="(block, i) of article.blocks"
                  :key="i"
                  class="blocks"
                >
                  <span
                    v-if="block.type === 'text'"
                    v-html="block.content"
                  ></span>
                  <iframe
                    v-if="block.type === 'video'"
                    class="video"
                    width="100%"
                    :src="block.url"
                    frameborder="0"
                    allow="encrypted-media;fullscreen;accelerometer; magnetometer; gyroscope"
                    allowfullscreen
                  ></iframe>
                  <div v-if="block.type === 'gallery'">
                    <ion-slides
                      v-if="
                        block.content != undefined && block.content.length > 1
                      "
                      pager="true"
                      :options="slideOpts"
                    >
                      <ion-slide v-for="(img, j) of block.content" :key="j">
                        <ion-img :src="img.url"></ion-img>
                      </ion-slide>
                    </ion-slides>
                    <img
                      v-if="
                        block.content != undefined && block.content.length === 1
                      "
                      :src="block.content"
                    />
                  </div>
                </div>
              </div>

              <ion-toolbar v-if="article.url" class="footer">
                <a>
                  <ion-icon class="oib" :src="`${publicPath}oib.svg`"></ion-icon
                  >CUMINAIVEL.CH
                </a>
              </ion-toolbar>
            </ion-content>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn
            :loading="deleteLoading"
            @click="deleteArticle()"
            :disabled="originalArticle.state === 'DELETED'"
            color="error"
            >Delete</v-btn
          >
        </v-col>
        <v-spacer></v-spacer>
        <v-col>
          <v-btn
            :loading="pubLoading"
            @click="publishChanges()"
            :disabled="
              saveSnack ||
                (originalArticle.state === 'PUBLISHED' &&
                  Object.entries(originalArticle.changes).length === 0)
            "
            color="success"
            >Publish</v-btn
          >
        </v-col>
      </v-row>
    </v-col>
    <v-dialog v-model="importFromURLDialog" width="500">
      <v-card>
        <v-card-title class="headline" primary-title
          >Import article from URL</v-card-title
        >
        <v-card-text>
          <v-text-field label="URL" v-model="importURL"></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="importFromURLDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            :loading="loadingFromURL"
            color="success"
            text
            @click="importFromURL"
            >Import</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import axios from "axios";
import Gallery from "@/components/Gallery.vue";
import SurveyBlock from "@/components/SurveyBlock.vue";
import TextBlock from "@/components/TextBlock.vue";
import VideoBlock from "@/components/VideoBlock.vue";
import { PUBLISHED, UNPUBLISHED, DELETED } from "../types";
export default {
  components: {
    SurveyBlock,
    TextBlock,
    VideoBlock,
    Gallery,
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      importFromURLDialog: false,
      loadingFromURL: false,
      importURL: "",
      article: {
        title: "",
        lead: "",
        pubDate: "",
        pubTime: "",
        blocks: [],
        homeType: "",
        id: "",
        url: "",
        picture: {},
        isCompact: false,
        tags: [],
      },
      pubLoading: false,
      deleteLoading: false,
      saveSnack: false,
      dateMenu: false,
      timeMenu: false,
      newBlockDialog: false,
      newBlockTypeRadio: "text",
      insertIndex: -1,
      deleteIndex: -1,
      deleteBlockDialog: false,
      slideOpts: {
        initialSlide: 1,
        speed: 500,
        autoplay: { delay: 5000 },
        pagination: {
          el: ".swiper-pagination",
          type: "fraction",
        },
      },
    };
  },
  computed: {
    originalArticle: function() {
      return this.$store.getters.articles.find(
        (a) => a.id === this.$route.params.id
      );
    },
  },
  created() {
    if (this.$route.params.new) {
      this.article.pubDate = new Date().toISOString().substring(0, 10);
      this.article.pubTime = new Date()
        .toLocaleTimeString()
        .split(":")
        .slice(0, 2)
        .join(":");
    }
    this.loadArticle();
  },
  methods: {
    manageTags: function() {
      console.log(this.article.tags);
    },
    checkEmbedOrModify: function() {
      console.log(this.article.picture.url);

      if (this.article.picture.url.indexOf("embed") === -1) {
        this.article.picture.url = this.article.picture.url.replace(
          "watch?v=",
          "embed/"
        );
      }
    },
    importFromURL: function() {
      this.loadingFromURL = true;
      axios
        .get(
          `https://cuminaivel-getarticle.herokuapp.com/getarticle?url=${this.importURL}`
        )
        .then((res) => {
          console.log(res);

          let newart = JSON.parse(JSON.stringify(this.originalArticle));
          Object.assign(newart, res.data);
          newart.picture = newart.imageSrc;
          delete newart.imageSrc;
          delete newart.text;
          newart.state = UNPUBLISHED;
          newart.homeType = "pictureFromURL";
          newart.isCompact = false;
          newart.blocks = [];
          newart.changes = {};
          var newBlock = {
            type: "text",
            content: res.data.text,
          };
          newart.blocks.push(newBlock);
          newart.shortid =
            newart.lang.toUpperCase().charAt(0) +
            (this.$store.state.settings.settings.shortids.val - 1);
          newart.pubTime = new Date()
            .toLocaleTimeString()
            .split(":")
            .slice(0, 2)
            .join(":");
          console.log("----", newart);

          return this.$store.dispatch("upsertArticle", newart);
        })
        .then(() => {
          this.loadArticle();
        })
        .catch((e) => console.log(e))
        .finally(() => {
          this.loadingFromURL = false;
          this.importFromURLDialog = false;
        });
    },
    selectHomeType: function() {
      this.saveSnack = true;
      this.article.picture = { images: [], caption: "", url: "" };
      if (this.article.homeType === "pictureFromURL") {
        this.article.picture.caption = "";
        this.article.picture.url = "";
      } else if (this.article.homeType === "linkYoutube") {
        this.article.picture.caption = "";
      }
    },
    loadArticle: function() {
      if (Object.entries(this.originalArticle.changes).length === 0) {
        this.article = JSON.parse(JSON.stringify(this.originalArticle));
      } else {
        this.article = JSON.parse(JSON.stringify(this.originalArticle.changes));
        console.log(this.originalArticle);
      }

      console.log(this.article);
    },
    undoChanges: function() {
      this.loadArticle();
      this.saveSnack = false;
    },
    saveChanges: function() {
      let tempArticle = {};
      tempArticle = JSON.parse(JSON.stringify(this.originalArticle));
      tempArticle.changes = JSON.parse(JSON.stringify(this.article));

      this.$store.dispatch("tags/patch", {
        list: {
          [this.article.lang]: [
            ...new Set([
              ...(this.article.tags || []),
              ...(this.$store.state.tags.tags.list[this.article.lang] || []),
            ]),
          ],
        },
      });
      this.$store
        .dispatch("upsertArticle", tempArticle)
        // .then(() => {
        //   this.article = tempArticle;
        //   this.article = Object.assign({}, this.tempArticle);
        // })
        .catch((err) => {
          console.log(err);
          this.undoChanges();
        })
        .finally(() => {
          this.saveSnack = false;
        });
    },
    publishChanges: function() {
      this.pubLoading = true;
      let tempArticle = {};
      tempArticle = JSON.parse(JSON.stringify(this.article));
      tempArticle.changes = ""; //firebase.firestore.FieldValue.delete();
      tempArticle.state = PUBLISHED;
      console.log(tempArticle);

      this.$store
        .dispatch("upsertArticle", tempArticle)
        // .then(() => {
        //   this.article = Object.assign({}, tempArticle);
        // })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.pubLoading = false;
        });
    },
    deleteArticle: function() {
      this.deleteLoading = true;
      let prevStat = this.article.state;
      this.article.state = DELETED;
      this.$store
        .dispatch("upsertArticle", this.article)
        .catch((err) => {
          console.log(err);
          this.undoChanges();
          this.article.state = prevStat;
        })
        .finally(() => {
          this.deleteLoading = false;
        });
    },
    deleteBlock: function() {
      this.article.blocks.splice(this.deleteIndex, 1);
      this.saveChanges();
      this.deleteBlockDialog = false;
    },
    addNewBlock: function() {
      var newBlock = {
        type: this.newBlockTypeRadio,
      };
      this.article.blocks =
        this.article.blocks !== undefined ? this.article.blocks : [];
      this.article.blocks.splice(this.insertIndex, 0, newBlock);
      this.saveChanges();
      this.newBlockDialog = false;
    },
  },
};
</script>
<style lang="scss">
.imgCaption {
  padding: 4px 8px 0px 8px;
  color: #acacac;
  font-size: smaller;
}
.cardPreview {
  height: -webkit-fill-available;
  margin-bottom: 56px;
}
.addBlockButton {
  position: relative;
  top: -20px;
}
.deleteBlockButton {
  position: relative;
  top: -20px;
  z-index: 100;
}
.h0 {
  height: 0;
}
.contentEditor {
  height: calc(100vh - 124px);
  overflow: auto;
}
.contentEditor {
  height: calc(100vh - 124px);
  overflow: auto;
}
.preview {
  height: calc(90vh - 144px);
  max-height: 700px;
  overflow: auto;
}
ion-content {
  --background: #1d2127;
}

ion-title {
  color: white;
}

ion-toolbar {
  --background: var(--ion-background-color);
}

ion-button {
  color: white;
  --border-color: white;
  --background: var(--ion-background-color);
}

ion-card {
  margin: 5px;
}

.video {
  //height: calc(100vw / 16 * 10);
}

#titleimg {
  height: 20px;
  // width: 222.54px;
}

.title {
  color: black;
  background: white;
  margin-top: 3px;
  display: block;
  padding: 3px;
  width: fit-content;
  font-weight: bold;
}

.pubDate {
  color: white;
}

.p5 {
  padding: 0px 8px;
}

.swissIcon {
  width: 2rem;
}

.text-larger {
  font-size: larger;
}

.lead {
  color: #acacac;
  font-weight: bold;
}

.color-white {
  color: white;
}

.down {
  --background: white;

  ion-icon {
    color: #bdbdbd;
  }
}

.up {
  --background: #f3ca3e;

  ion-icon {
    color: white;
  }
}

#likeButton {
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.58);
  border-radius: 50%;
  position: relative;
  bottom: 5px;
  right: 5px;

  ion-icon {
    font-size: 36px;
  }
}

.footer {
  --background: #1d2127;
  text-align: center;

  a {
    text-decoration: none;
    font-weight: bold;
  }
}

.oib {
  font-size: 24px;
  position: relative;
  top: 6px;
}

ion-slides {
  .swiper-pagination {
    background: rgba(1, 1, 1, 0.6) !important;
    bottom: 0 !important;
    padding-top: 1% !important;
    height: 13% !important;
    text-align: left !important;
    padding-left: 10px !important;
  }
}

.ml--10 {
  margin-left: -10px;
}

.blocks {
  margin-bottom: 10px;
}

:root {
  --ion-background-color: #587b97;
  --ion-color-primary: #587b97;
  --ion-color-primary-rgb: 88, 123, 151;
  --ion-color-primary-shade: #4d6c85;
}
</style>
